var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaid = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#2BA18D",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 16h16v-2H12v2Zm-2-2c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 12 12h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v5c0 .283-.096.52-.288.712A.968.968 0 0 1 29 20H12v6h3.1c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.288.712A.968.968 0 0 1 15.1 28H12c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 26V14Zm2 0v12-3.262 1.587V14Zm10.95 15.6a.942.942 0 0 1-.375-.075 1.038 1.038 0 0 1-.325-.225l-2.85-2.85a.977.977 0 0 1-.287-.688.93.93 0 0 1 .287-.712.933.933 0 0 1 .688-.275c.274 0 .512.092.712.275l2.15 2.1 4.925-4.925a.93.93 0 0 1 .712-.288c.276.009.513.113.713.313.183.2.28.433.287.7a.916.916 0 0 1-.287.7l-5.65 5.65c-.1.1-.208.175-.325.225a.942.942 0 0 1-.375.075Z"
})));
SvgPaid.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaid);
export default ForwardRef;